import { CanonicalsView } from '@src/pages/Canonicals/CanonicalsView';
import { CanonicalsProvider } from './CanonicalsContext';

export const CanonicalsContainer = () => {
  return (
    <CanonicalsProvider>
      <CanonicalsView />
    </CanonicalsProvider>
  );
};
